import React from 'react';
import Select from 'react-select';
import { customStyles } from './elements';

function DropDownSelect(props) {
  const {
    options,
    isClearable,
    placeholder,
    defaultValue,
    isSearchable,
    onChange,
    ...rest
  } = props;

  return (
    <div {...rest}>
      <Select
        components={{ IndicatorSeparator: () => null }}
        onChange={onChange}
        styles={customStyles}
        placeholder={placeholder}
        defaultValue={defaultValue}
        options={options}
        isClearable={isClearable ? isClearable : false}
        isSearchable={isSearchable ? isSearchable : false}
      />
    </div>
  );
}

export default DropDownSelect;
